import isIContext from '../../isIContext';
export function isILinkRemoteData(possible) {
    if (possible === null || typeof possible !== 'object') {
        return false;
    }
    const {id, context} = possible;
    return typeof id === 'string' && isIContext(context);
}
export {
    isILinkRemoteData as isIData
};
export default isILinkRemoteData;    //# sourceMappingURL=isIData.js.map
